import BriefGuide from '@elem/compCommon/ProductConstructor/BriefGuide';
import ProductSupport from '@elem/compCommon/ProductConstructor/Support';
import ProductSpecs from '@elem/compCommon/ProductConstructor/Specs';
import ProductMedia from '@elem/compCommon/ProductConstructor/Media';
import ProductBundles from '@elem/compCommon/ProductConstructor/Bundles';
import BundlePopup from '@elem/compPage/DeltaProUltra/Launch//BundlePopup';
import { createPortal } from 'react-dom';
import QuoteForm from '@elem/compCommon/ProductConstructor/BriefGuide/Info/QuoteForm';
import css from './index.module.scss';
import ProductDetail from './Detail';
import { useGlobal } from '@/utils/useGlobal';
import { useSupportData } from '@/utils/hooks';
import { getProductMsg, getProductFromGeneralKey } from '@/utils/productGetServerSideProps';

// 产品详情页参数
const generalKey = 'product_home_yj751';
export default function DPUDailyUse({ theme }: any) {
    const { useState, useRouter, gloproductlist, useEffect, gtm } = useGlobal();
    const router = useRouter();
    const { locale, query } = router;
    const [freeQuote, setFreeQuote] = useState(false);
    const [isClient, setIsClient] = useState(false);
    const [showBundlePop, setShowBundlePop] = useState(false);

    // 从全局的列表中--获取产品详情的基本信息
    const productMsg = getProductFromGeneralKey({ gloproductlist, generalKey: generalKey });

    const [resProductCatagory, productDetail, supportData] = useSupportData(getProductMsg, locale, productMsg, productMsg?.spuId || productMsg?.sourceId);

    const data: any = {
        langKey: 'delta_pro_ultra_daily_use.launch',
        briefGuide: {
            swiper: [
                {
                    img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716798892077/top%202.png',
                    imgPad: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716798930543/ae01.png',
                },
                {
                    img: `/responsive/picture/delta-pro-ultra-daily-use/swiper2.jpg`,
                    imgPad: `/responsive/picture/delta-pro-ultra-daily-use/swiper2_768.jpg`,
                },
                {
                    img: '/responsive/picture/delta-pro-ultra-daily-use/swiper3.jpg',
                    imgPad: '/responsive/picture/delta-pro-ultra-daily-use/swiper3_768.jpg',
                },
            ],
            info: {
                subtitle: 'brief_guide.info.subtitle',
                title: 'brief_guide.info.title',
                desc: 'brief_guide.info.desc',
                textArr: ['brief_guide.info.text1', 'brief_guide.info.text2', 'brief_guide.info.text3'],
                tip: 'brief_guide.info.tip',
                productId: (() => {
                    const localMap: any = {
                        us: '7066236649545',
                    };
                    return localMap[locale] || undefined;
                })(),
                variantId: (() => {
                    const localMap: any = {
                        us: '41114200506441',
                    };
                    return localMap[locale] || undefined;
                })(),
            },
        },
        menu: {
            title: [
                { product: 'menu.dpu', url: `/${locale}/delta-pro-ultra-daily-use` },
                { product: 'menu.shp2', url: `/${locale}/smart-home-panel-2?back=/delta-pro-ultra-daily-use` },
            ],
        },
        bundles: {
            data: [
                {
                    title: 'bundles.bundle1_title',
                    name: 'bundles.bundle1_name',
                    power: 'bundles.bundle1_power',
                    desc: 'bundles.bundle1_desc',
                    img:
                        locale === 'jp'
                            ? '/responsive/picture/delta-pro-ultra/launch/bundle1_jp.png'
                            : '/responsive/picture/common-products/bundle_smart_control_kit.png',
                    install: locale === 'us',
                    productId: (() => {
                        const localMap: any = {
                            us: '6972483010633',
                            ca: '8019129434266',
                            jp: '7835102478497',
                        };
                        return localMap[locale] || undefined;
                    })(),
                    variantId: (() => {
                        const localMap: any = {
                            us: '40790293184585',
                            ca: '44286125047962',
                            jp: '43695277965473',
                        };
                        return localMap[locale] || undefined;
                    })(),
                    subs: ['us', 'ca'].includes(locale)
                        ? [
                              {
                                  subtitle: 'bundles.subs.subtitle',
                                  title: 'bundles.subs.battery',
                                  img: '/responsive/picture/common-products/DPU_Battery.png',
                                  limit: 4,
                                  parentVariantId: (() => {
                                      const localMap: any = {
                                          us: '40790293184585',
                                          ca: '44286125047962',
                                          jp: '43695281438881',
                                      };
                                      return localMap[locale] || undefined;
                                  })(),
                                  productId: (() => {
                                      const LocalMap: any = {
                                          us: '6965707112521',
                                          ca: '8012436209818',
                                      };
                                      return LocalMap[locale] || LocalMap.us;
                                  })(),
                                  variantId: (() => {
                                      const LocalMap: any = {
                                          us: '41446274465865',
                                          ca: '44960085639322',
                                      };
                                      return LocalMap[locale] || LocalMap.us;
                                  })(),
                              },
                          ]
                        : null,
                },
                {
                    title: 'bundles.bundle2_title',
                    name: 'bundles.bundle2_name',
                    power: 'bundles.bundle2_power',
                    desc: 'bundles.bundle2_desc',
                    img: `/responsive/picture/common-products/bundle_intelligent_kit${locale === 'us' ? '_us' : ''}.png`,
                    install: locale === 'us',
                    productId: (() => {
                        const localMap: any = {
                            us: '6972484026441',
                            ca: '8019129794714',
                        };
                        return localMap[locale] || undefined;
                    })(),
                    variantId: (() => {
                        const localMap: any = {
                            us: '40790304063561',
                            ca: '44286125965466',
                        };
                        return localMap[locale] || undefined;
                    })(),
                    subs: ['us', 'ca'].includes(locale)
                        ? [
                              {
                                  subtitle: 'bundles.subs.subtitle',
                                  title: 'bundles.subs.battery',
                                  img: '/responsive/picture/common-products/DPU_Battery.png',
                                  limit: 4,
                                  parentVariantId: (() => {
                                      const localMap: any = {
                                          us: '40790304063561',
                                          ca: '44286125965466',
                                      };
                                      return localMap[locale] || undefined;
                                  })(),
                                  productId: (() => {
                                      const LocalMap: any = {
                                          us: '6965707112521',
                                          ca: '8012436209818',
                                      };
                                      return LocalMap[locale] || LocalMap.us;
                                  })(),
                                  variantId: (() => {
                                      const LocalMap: any = {
                                          us: '41446274465865',
                                          ca: '44960085639322',
                                      };
                                      return LocalMap[locale] || LocalMap.us;
                                  })(),
                              },
                          ]
                        : null,
                },
                {
                    title: 'bundles.bundle3_title',
                    name: 'bundles.bundle3_name',
                    power: 'bundles.bundle3_power',
                    desc: 'bundles.bundle3_desc',
                    ship: 'bundles.bundle3_ship',
                    install: locale == 'us',
                    link: locale === 'us' ? 'How Does It Work?' : '',
                    img:
                        locale === 'jp'
                            ? '/responsive/picture/delta-pro-ultra/launch/bundle2_jp.png'
                            : locale === 'us'
                            ? '/responsive/picture/common-products/hassel-free.png'
                            : '/responsive/picture/common-products/bundle_smart_control_kit.png',
                    productId: (() => {
                        const localMap: any = {
                            jp: '7835103494305',
                            us: '7013514936393',
                        };
                        return localMap[locale] || undefined;
                    })(),
                    variantId: (() => {
                        const localMap: any = {
                            jp: '43695279997089',
                            us: '40944017440841',
                        };
                        return localMap[locale] || undefined;
                    })(),
                    subs: ['us'].includes(locale)
                        ? [
                              {
                                  subtitle: 'bundles.subs.subtitle',
                                  title: 'bundles.subs.battery',
                                  img: '/responsive/picture/common-products/DPU_Battery.png',
                                  limit: 4,
                                  parentVariantId: (() => {
                                      const localMap: any = {
                                          us: '40944017440841',
                                      };
                                      return localMap[locale] || undefined;
                                  })(),
                                  productId: (() => {
                                      const LocalMap: any = {
                                          us: '6965707112521',
                                      };
                                      return LocalMap[locale] || LocalMap.us;
                                  })(),
                                  variantId: (() => {
                                      const LocalMap: any = {
                                          us: '41446274465865',
                                      };
                                      return LocalMap[locale] || LocalMap.us;
                                  })(),
                              },
                          ]
                        : null,
                },
                {
                    title: 'bundles.bundle4_title',
                    name: 'bundles.bundle4_name',
                    power: 'bundles.bundle4_power',
                    desc: 'bundles.bundle4_desc',
                    img:
                        locale === 'jp'
                            ? '/responsive/picture/delta-pro-ultra/launch/bundle3_jp.png'
                            : '/responsive/picture/common-products/bundle_intelligent_kit.png',
                    productId: (() => {
                        const localMap: any = {
                            jp: '7835105001633',
                        };
                        return localMap[locale] || undefined;
                    })(),
                    variantId: (() => {
                        const localMap: any = {
                            jp: '43695280980129',
                        };
                        return localMap[locale] || undefined;
                    })(),
                },
            ],
            customize:
                locale === 'us'
                    ? {
                          link: '/customize-bundle-for-dpu',
                          img: '/responsive/picture/common-products/customize_bundle.png',
                      }
                    : null,
            shipping: ['ca'].includes(locale),
        },
        media: {
            mediaBanner: {
                title: 'media.media_title',
                img: '/responsive/picture/delta-pro-ultra/launch/media_banner.jpg',
                imgPad: '/responsive/picture/delta-pro-ultra/launch/media_banner_768.jpg',
            },
            mediaList: [
                {
                    poster: '/responsive/picture/delta-pro-ultra/launch/media0.jpg',
                    title: 'media.list0',
                    link: 'https://www.youtube.com/embed/JcKq6neGxXk?si=XrB0G7e6w7PcrV31',
                },
                {
                    poster: '/responsive/picture/delta-pro-ultra/launch/media1.jpg',
                    title: 'media.list1',
                    link: 'https://www.youtube.com/embed/i__nMuz6M74?si=veweiOuE3qlS4UdM',
                },
                {
                    poster: '/responsive/picture/delta-pro-ultra/launch/media2.jpg',
                    title: 'media.list2',
                    link: 'https://www.youtube.com/embed/WDGzPCrw7FY?si=iRAw9l_sQQ0wQ5Rd',
                },
                {
                    poster: '/responsive/picture/delta-pro-ultra/launch/media3.jpg',
                    title: 'media.list3',
                    link: 'https://www.youtube.com/embed/TeoXospthac?si=QTzTEJ0JK0XKdjP5',
                },
                {
                    poster: '/responsive/picture/delta-pro-ultra/launch/media4.jpg',
                    title: 'media.list4',
                    link: 'https://www.youtube.com/embed/suphdNkkrN4?si=emJrHJgQ80bjsfX7',
                },
                {
                    poster: '/responsive/picture/delta-pro-ultra/launch/media5.jpg',
                    title: 'media.list5',
                    link: 'https://www.youtube.com/embed/_zYHtNnuO-A?si=sTEedcfu_cIb8LRI',
                },
            ],
        },
    };

    const { briefGuide, langKey, bundles, menu, media } = data;
    const hasSupportFlag =
        supportData?.downloadList?.length > 0 || supportData?.videoList?.length > 0 || supportData?.faqList?.length > 0 || supportData?.onlineList?.length > 0;

    const allow_tabs: string[] = ['product', 'bundles', 'support', 'specs', 'media'];
    const [tab, setTab] = useState(query?.tab && allow_tabs.includes(query?.tab?.toLowerCase()) ? query?.tab?.toLowerCase() : allow_tabs[0]);
    const defaultTabObj: any = {
        product: false,
        support: false,
        bundles: false,
        specs: false,
        media: false,
    };
    const [changedTab, setChangedTab] = useState(
        query?.tab && allow_tabs.includes(query?.tab?.toLowerCase())
            ? { ...defaultTabObj, [query?.tab?.toLowerCase()]: true }
            : { ...defaultTabObj, [allow_tabs[0]]: true },
    );

    const handleScroll = () => {
        if (typeof window !== 'undefined') {
            const barLine = document.querySelector('.top-bar-line') as HTMLElement;
            const header = document.querySelector('.ecoflow-frame-header') as HTMLElement;
            if (barLine) {
                window.scrollTo({
                    top: barLine?.offsetTop + (header?.offsetHeight || 0),
                    behavior: 'smooth', // 可选，平滑滚动
                });
            }
        }
    };

    const handleChangeTab = (tab: string) => {
        setTab(tab);
        if (!changedTab[tab]) {
            setChangedTab({ ...changedTab, [tab]: true });
        }
        if (query?.tab) {
            router.push(
                {
                    pathname: router.pathname,
                    query: { tab: tab },
                },
                undefined,
                { shallow: true, replace: true },
            );
        }
        const bar = document.querySelector('.product-announcement-bar') as HTMLElement;
        if (bar) {
            handleScroll();
        } else {
            const menu = document.querySelector('.product-menu') as HTMLElement;
            if (menu) {
                handleScroll(); // 初始滚动到指定元素位置
            }
        }
    };

    const hadleOpenQuote = () => {
        setFreeQuote(true);
        gtm.push({
            event: 'uaEvent',
            event_name: 'click_get_a_quote',
            product_name: 'EcoFlow DELTA Pro Ultra + Smart Home Panel 2',
            position: 'Introduction',
            option_name: 'Get a Free Quote',
        });
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    useEffect(() => {
        if (typeof window !== 'undefined' && allow_tabs?.includes(query?.tab?.toLowerCase())) {
            const bar = document.querySelector('.product-announcement-bar') as HTMLElement;
            if (bar) {
                handleScroll(); // 初始滚动到指定元素位置

                window.addEventListener('load', handleScroll);

                return () => {
                    window.removeEventListener('load', handleScroll);
                };
            } else {
                const menu = document.querySelector('.product-menu') as HTMLElement;
                if (menu) {
                    handleScroll(); // 初始滚动到指定元素位置
                    window.addEventListener('load', handleScroll);
                    return () => {
                        window.removeEventListener('load', handleScroll);
                    };
                }
            }
        }
    }, [allow_tabs, query?.tab]);

    useEffect(() => {
        if (typeof window !== 'undefined' && tab.toLowerCase() === 'bundles' && locale === 'us') {
            const bundles = document.querySelectorAll('.product-bundles .bundles .bundle');
            const toggleBundlePop = () => {
                setShowBundlePop(true);
            };
            if (bundles[2]) {
                const target = bundles[2].querySelector('.bundle-img');
                if (target) {
                    target.style.cursor = 'pointer';
                    target.addEventListener('click', toggleBundlePop);
                    return () => target.removeEventListener('click', toggleBundlePop);
                }
            }
        }
    }, [tab, locale]);

    return (
        <div className={`delta-pro-ultra-launch ${css['delta-pro-ultra-launch']}`}>
            <BriefGuide
                briefGuide={briefGuide}
                langKey={langKey}
                callBuy={() => handleChangeTab('bundles')}
                freeQuoteBack={setFreeQuote}
                freeQuote={freeQuote}
            />
            <p className="top-bar-line"></p>
            <div className="product-announcement-bar daily-bar" onClick={hadleOpenQuote}>
                Call us or fill the form to get a free comprehensive evaluation and exclusive offers. &gt;
            </div>
            {changedTab.product && (
                <div className={`tab-container ${tab === 'product' ? 'active' : ''}`}>
                    <ProductDetail freeQuote={freeQuote} freeQuoteBack={setFreeQuote} />
                    <ProductSpecs productCatagory={resProductCatagory} productDetail={productDetail} theme={theme} />
                    <div className="daily-use-form">
                        <div className="daily-use-form-title">{`We're Here to Help`}</div>
                        <div className="daily-use-form-desc">
                            Our experts are waiting to assist you. Leave your questions and contact details, and we'll be in touch within 2 business days
                        </div>
                        <QuoteForm />
                    </div>
                </div>
            )}
            {changedTab.bundles && (
                <div className={`tab-container ${tab === 'bundles' ? 'active' : ''}`}>
                    <ProductBundles
                        langKey={langKey}
                        bundles={bundles?.data?.filter((bundle: any) => bundle?.variantId)}
                        customize={bundles?.customize}
                        shipping={bundles?.shipping}
                        callbackLink={() => setShowBundlePop(true)}
                    />
                    {isClient && showBundlePop && createPortal(<BundlePopup callback={() => setShowBundlePop(false)} />, document.body)}
                </div>
            )}
            {changedTab.support && hasSupportFlag && (
                <div className={`tab-container ${tab === 'support' ? 'active' : ''}`}>
                    <ProductSupport supportData={supportData} theme={theme} spuId={productMsg?.spuId || productMsg?.sourceId} />
                </div>
            )}
            {changedTab.specs && resProductCatagory && productDetail && (
                <div className={`tab-container ${tab === 'specs' ? 'active' : ''}`}>
                    <ProductSpecs productCatagory={resProductCatagory} productDetail={productDetail} theme={theme} />
                </div>
            )}
            {changedTab.media && media?.mediaList?.length > 0 && (
                <div className={`tab-container ${tab === 'media' ? 'active' : ''}`}>
                    <ProductMedia langKey={langKey} mediaBanner={media?.mediaBanner} mediaList={media?.mediaList} theme={theme} />
                </div>
            )}
            <style jsx global>
                {`
                    .festival-bar,
                    .announcement-bar {
                        position: relative;
                    }
                `}
            </style>
        </div>
    );
}
